var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1027 9.44024C11.0831 8.92692 11.4906 8.5 12.0001 8.5C12.5097 8.5 12.9172 8.92692 12.8976 9.44025L12.6924 14.8183C12.6781 15.1933 12.3724 15.4899 12.0001 15.4899C11.6279 15.4899 11.3222 15.1933 11.3079 14.8183L11.1027 9.44024ZM13 17.4918C13 18.0486 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0486 11 17.4918C11 16.9351 11.4477 16.4837 12 16.4837C12.5523 16.4837 13 16.9351 13 17.4918Z",
    fill: "#EAB308"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5731 21C2.12689 21 1.85238 20.5202 2.0841 20.1454L11.5148 3.27191C11.7389 2.90936 12.2611 2.90936 12.4852 3.27191L21.9159 20.1454C22.1476 20.5202 21.8731 21 21.4269 21H2.5731Z",
    stroke: "#EAB308",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0fbdb0f363290199e0a907f74cc64960.svg";
export { ForwardRef as ReactComponent };